import React, { useState, useEffect, useContext } from 'react';

import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import Pagination from './Pagination';
import {UserContext} from '../../providers/UserProvider';

import '../css/Components.css';

const Questions = ({match}) =>{

	const {currentUser} =useContext(UserContext);

	const [done, setDone] = useState(false);
	const [restricted, setRestricted] = useState(false);
	const [msg, setMsg] =useState("Content Restricted");

	const [curEx, setCurrentExercise] = useState("");
	const [allQuestions, setQuestions] = useState([]);
	
	useEffect(() => {
		var postObj = {
			method: 'POST',
			cache: 'no-cache',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({ch: match.params.ch, i: match.params.i, email:currentUser.email})
		}
		const getQuestions =async () => {
			const response = await fetch(process.env.REACT_APP_FLASK_API+'get_questionsList', postObj);
			const data = await response.json();
			setRestricted(data.restricted);
			setMsg(data.msg);

			setQuestions(data.list);
			setCurrentExercise(data.curEx);

			setDone(true);
		};
		getQuestions();
   }, [match.params.ch, match.params.i, currentUser.email]);

   	// Pagination
	const [currentPage, setCurrentPage] = useState(1);
	const objsPerPage = 10;
	// Get current list of quesitons
	const indexOfLastObj = currentPage * objsPerPage;
	const indexOfFirstObj = indexOfLastObj - objsPerPage;
	const currentQues = allQuestions.slice(indexOfFirstObj, indexOfLastObj);
	// Change Page
	const paginate =pageNumber => setCurrentPage(pageNumber);

	var first=true;
	var lastQ =0, showQ=false; 

	if (restricted){
		return(<h1>{msg}</h1>)
	}
   	if(done && allQuestions.length===0){
		return(<h1>No such exercise</h1>)
	}

	const explainColor =(ques) =>{
		return (
			<Tooltip style={{fontWeight:'bold'}}>
				{ques.variant==='primary' &&
					"Unattempted"
				}
				{ques.variant==='warning' &&
					"Incorrect or incomplete"
				}
				{ques.variant==='success' &&
					"Answered correctly"
				}
			</Tooltip>
		);
	};
	
	return (
		<div>
			<Breadcrumb>
 				<Breadcrumb.Item href={ `/ch=${match.params.ch}`}>{`Chapter ${match.params.ch}`}</Breadcrumb.Item>
 				<Breadcrumb.Item href="#" active>{curEx}</Breadcrumb.Item>
 			</Breadcrumb>

			<div className="widthVW d-grid gap-2 mb-3">
				{currentQues.map(ques => {
					
					showQ=false;
					if (first){
						lastQ=ques.n;
						showQ=true;first=false;
					}
					else if (lastQ<ques.n){
						lastQ+=1; showQ=true;
					}
					
					return (
						<OverlayTrigger
							placement='top'
							key={ques.index}
							overlay={explainColor(ques)}
						>
							<Button style={{textAlign: "left"}} size="lg"
									variant={ques.variant} disabled={ques.disabled}
									href={ `/ch=${match.params.ch}/${match.params.i}/${ques.index}`}>
								
								{showQ 
								?
									<>Q.{ques.n} <span style={{marginLeft:'2px'}}>Sentence {ques.s}</span></>
								:
									<span style={{marginLeft:'38px'}}>Sentence {ques.s}</span>
								}
								
							</Button>
						</OverlayTrigger>
				)})}
			</div>

			<Pagination objsPerPage={objsPerPage} totalObjs={allQuestions.length} paginate={paginate}/>
		
		</div>
	);
};

export default Questions;